export default "__VITE_ASSET__D3xWh4Nz__"